import { Avatar, type AvatarProps, styled } from '@mui/material';
import { type FC } from 'react';

const CustomStyledAvatar = styled(Avatar)(({ theme }) => ({
  backgroundColor: theme.palette.action.hover,
  borderColor: theme.palette.common.white,
  borderWidth: 1,
  '& img': {objectFit: 'cover', objectPosition: 'top',},
}));

const CustomAppAvatar: FC<AvatarProps> = (props) => {
  return <CustomStyledAvatar {...props} />;
};

export default CustomAppAvatar;